import Dialog from '@mui/material/Dialog';
import { default as React } from 'react';

import { IClaimLinkTemplate } from '../../../../types/templates';
import { ConfirmationDialog } from '../ConfirmationDialog';
import { dialogPaperStyles } from './chooseTemplateModal.styles';
import { InfiniteTemplatesBody } from './components/InfiniteTemplatesBody';
import { ModalTitle } from './components/ModalTitle';
import { PaginatedTemplatesBody } from './components/PaginatedTemplatesBody';
import { useTemplateSelection } from './hooks/useTemplateSelection';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (template: IClaimLinkTemplate) => void;
  currentTemplateId?: string;
  campaignTemplateId?: string;
  title?: string;
  // Show confirmation when the selected template has department restrictions (org default flow only)
  showDepartmentDialog?: boolean;
  // When set, only templates that belong to this department are shown
  departmentId?: string;
  // When set, fetches templates for the specified org instead of the current user's org
  orgId?: string;
  withFooterActions?: boolean;
  withInfiniteScroll?: boolean;
}

export const ChooseClaimLinkTemplateModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  onSelect,
  currentTemplateId,
  campaignTemplateId,
  title = 'Choose a template',
  showDepartmentDialog = false,
  departmentId,
  orgId,
  withFooterActions = false,
  withInfiniteScroll = false,
}) => {
  const {
    cardConfig,
    hasSelection,
    handleSubmit,
    confirmSubmit,
    isDepartmentConfirmOpen,
    handleDepartmentConfirmClose,
    departmentConfirmMessage,
  } = useTemplateSelection({
    isOpen,
    onClose,
    onSelect,
    currentTemplateId,
    campaignTemplateId,
    showDepartmentDialog,
  });

  const bodyProps = {
    isOpen,
    onClose,
    onSubmit: handleSubmit,
    hasSelection,
    cardConfig,
    departmentId,
    orgId,
    withFooterActions,
  };

  return (
    <Dialog open={isOpen} onClose={onClose} sx={dialogPaperStyles}>
      <ModalTitle onClose={onClose} title={title} />
      {withInfiniteScroll ? <InfiniteTemplatesBody {...bodyProps} /> : <PaginatedTemplatesBody {...bodyProps} />}
      <ConfirmationDialog
        open={isDepartmentConfirmOpen}
        title="Set as organization default?"
        message={departmentConfirmMessage}
        confirmButtonText="Set as default"
        onClose={handleDepartmentConfirmClose}
        onConfirm={confirmSubmit}
      />
    </Dialog>
  );
};
